import { INavigationStatus } from "./navigation-status";
import { IScreenStatusCommand } from "./screen-status-command";
import { IScreenController } from "./screens/screen-controller";

/**
 * Class in charge of controlling the behaviour of the wizard buttons and the
 * progress bar 
 */
export class NavigationBarManager {

    totalNumberOfStepsInBar: number = 3;

    ButtonNext = $("#btn-next-screen");

    ButtonPrev = $("#btn-previous-screen");

    ButtonCloseApp = $("#btn-close-app");

    ButtonExit = $("#btn-exit");

    ButtonStartOver = $("#btn-start-over");

    ProgressBar = $(".Form__NavigationBar .Form__NavigationBar__ProgressBar--Progress");

    UpNextLabel = $("#lbl-up-next");

    screens: Array<IScreenController>;

    constructor(screens: Array<IScreenController>) {
        this.screens = screens;
    }
    /**
     * Shows or hides the navigation bar based on the status sent as
     * parameter
     */
    public updateNavigationBarStatus(activeScreenIndex:number, status: INavigationStatus) {

        this.setPrevActiveStatus(activeScreenIndex);
        this.updateProgressBar(status.progressBarGroupIndex);

        if (status.showCloseApp) {
            this.ButtonCloseApp.show();
        } else {
            this.ButtonCloseApp.hide();
        }

        if (status.showExit) {
            this.ButtonExit.show();
        } else {
            this.ButtonExit.hide();
        }

        if (status.showNext) {
            this.ButtonNext.show();
        } else {
            this.ButtonNext.hide();
        }

        if (status.showPrevious) {
            this.ButtonPrev.show();
        } else {
            this.ButtonPrev.hide();
        }

        if (status.showStartOver) {
            this.ButtonStartOver.show();
        } else {
            this.ButtonStartOver.hide();
        }
    }

    /**
     * Enables and disables Next and Prev button if the 
     * start or the end of the flow is reached
     */
    private setPrevActiveStatus(activeScreenIndex: number): void {
        if (activeScreenIndex - 1 < 0) {
            this.ButtonPrev.prop('disabled', true);
        } else {
            this.ButtonPrev.prop('disabled', false);
        }
    }

    /**
     * Updates the progress bar according to the current screen
     */
    private updateProgressBar(activeScreenIndex: number): void {

        // We substract one to the total number of steps because 
        // the activeScreenIndex is a zero-based number
        let progressPercentage = (activeScreenIndex / (this.totalNumberOfStepsInBar - 1)) * 100.0;
        this.activateStepNumber(activeScreenIndex);
        this.ProgressBar.attr("style", `width: ${progressPercentage}%;`)
    }

    public updateNextButtonTitle(title: string) {
        this.ButtonNext.html(title);
    }

    public enableNextButton() {
        this.ButtonNext.prop('disabled', false);
    }

    public disableNextButton() {
        this.ButtonNext.prop('disabled', true);
        this.clearUpNextLable();
    }

    public updateUpNextLable(screenStatusCommand: IScreenStatusCommand) {
        let nextScreen = this.screens[screenStatusCommand.targetScreenIndex];
        this.UpNextLabel.html("Up Next: <strong>" + nextScreen.getScreenTitle() + "</strong>");
    }

    public clearUpNextLable() {
        this.UpNextLabel.html("");
    }

    public showProgressBar() {
        this.ProgressBar.show();
    }

    public hideProgressBar() {
        this.ProgressBar.hide();
    }

    public enablePrevButton() {
        this.ButtonPrev.prop('disabled', false);
    }

    public activateStepNumber(index: number) {
        const steps = document.querySelectorAll('.progress-bar-step');
        steps.forEach((step: HTMLElement) => {
            step.classList.remove('visited-step'); // reset styles when prev button clicked
            let stepIndex: number = parseInt(step.dataset.stepIndex);
            if (stepIndex <= index) {
                step.classList.add('visited-step');
            }
        });
    }
}